document.addEventListener("DOMContentLoaded", function () {

  console.log("⏳ Waiting 5 seconds for Yotpo reviews...");

  setTimeout(() => {
    console.log(true);
    const reviews = document.querySelectorAll('#yotpo-seo-reviews-container .yotpo-review');

    if (!reviews.length) {
      console.log("❌ No reviews found.");
      return;
    }

    console.log(`✅ Found ${reviews.length} reviews`);

    reviews.forEach((rev, i) => {

      const name = rev.querySelector('.yotpo-reviewer-name')?.innerText.trim();
      const title = rev.querySelector('.yotpo-review-title')?.innerText.trim();
      const content = rev.querySelector('.yotpo-read-more-text')?.innerText.trim();
      const date = rev.querySelector('.yotpo-date-format')?.innerText.trim();
      const product = rev.querySelector('.yotpo-text-link-name')?.innerText.trim();
      const rating = rev.querySelector('.yotpo-review-star-rating')?.getAttribute('aria-label');

      console.log(`\nReview ${i + 1}`);
      console.log("Name:", name);
      console.log("Title:", title);
      console.log("Rating:", rating);
      console.log("Product:", product);
      console.log("Date:", date);
      console.log("Content:", content);

    });

  }, 5000);

  console.log(true, 'bottom');
});